import React, {useState} from 'react'
import moment from 'moment';
import {Select, Typography, Row, Col, Avatar, Card} from 'antd'
import Spinner from '../spinner/Spinner'
import { useGetNewsQuery } from '../services/NewsApi'
import { useGetCryptosQuery } from '../services/cryptoApi'

const {Text, Title} = Typography;
const {Option} = Select;
const heroImage = "https://bitcoin.org/img/icons/logotop.svg?1644775669"

function News({simplified}) {
  // const counted = simplified ? 10 : 4;
  // console.log(counted)
  const [categories, setCategories] = useState('cryptocurrencies')
  const {data: cryptoNews, isFetching} = useGetNewsQuery({category:categories,count:simplified?4:100});
  const {data: cryptoCoins, isGetting} = useGetCryptosQuery(100)
  if(isFetching) return <Spinner/>
  if(isGetting) return <Spinner/>
  console.log(cryptoNews)
  console.log(cryptoCoins)
  return (
    <div>
      <Row gutter={[24,24]}>
        {!simplified && (
          <Col span={24}>
            <Select
            showSearch
            className='select-news'
            placeholder='Select a Crypto'
            optionFilterProp='children'
            onChange={(value)=> setCategories(value)}
            filterOption={(input,option)=> option.children.toLowerCase().indexOf(input.toLowerCase()>=0)}
            >
              <Option value="Cryptocurrency">Cryptocurrency</Option>
              {cryptoCoins?.data?.coins.map((coin)=>
              <Option value={coin.name}>{coin.name}</Option>
              )}
            </Select>
          </Col>
        )}
        {cryptoNews.value.map((news,i)=>(
          <Col xs={24} sm={12} lg={8} key={i}>
            <Card hoverable className='news-card'>
              <a href={news.url} target="_blank" rel="noreferrer">
                <div className="news-image-container">
                  <Title className='news-title' level={4}>{news.name}</Title>
                  <img style={{maxWidth:'100px',maxHeight:'100px'}} src={news?.image?.thumbnail?.contentUrl || heroImage} alt="" />
                </div>
                <p>
                  {news.description.length > 150 ? `${news.description.substring(0,150)}...`: news.descripton}
                </p>
                <div className='provider-container'>
                <div>
                  <Avatar src={news.provider[0].image?.thumbnail?.contentUrl || heroImage}/>
                  <Text className='provider-name'>{news.provider[0]?.name}</Text>
                </div>
                <Text>{moment(news.datePublished).startOf('ss').fromNow()}</Text>
                </div>
                </a>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default News